import { render, staticRenderFns } from "./OfficialDocuments.vue?vue&type=template&id=133a4922&scoped=true"
var script = {}
import style0 from "./OfficialDocuments.vue?vue&type=style&index=0&id=133a4922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a4922",
  null
  
)

export default component.exports